import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogInitiativesInitiativeInvestmentsRoute extends Route {
  @service store;

  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    model.bon.then(async (results) => {
      const bon = results ?? this.store.createRecord('bon');
      // if (bon.id) {
      //   await this.revalidateImages(bon);
      // }
      controller.set('bon', bon);
      // controller.set('editMode', true);

      //if a bon object already exists run formatBon to fill value fields in the object
      if (bon.id) {
        controller.get('formatBon')?.();
      }
    });
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativeInvestmentsRoute,
);
